/**
 * Lottie Player
 */

export default function LottiePlayer() {
    const selectors = {
        'lottie' : '.js-trigger-lottie',
    };

    this.init = () => {
        this.lottie();
    };

    this.lottie = () => {
        jQuery(selectors.lottie).hover(function(){
            let id = jQuery(this).attr('data-lottie-id');
            let elm = document.getElementById(id);
            if(elm != null)
                elm.play()
        }, function(){
            let id = jQuery(this).attr('data-lottie-id');
            let elm = document.getElementById(id);
            if(elm != null)
                elm.stop()
        })
    }

}
